import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SafePipe } from 'lib/pipes/safe.pipe';
import { WebpService } from 'lib/services/webp.service';

@Component({
    selector: 'product-recommended',
    templateUrl: './product-recommended.component.html',
    styleUrls: ['./product-recommended.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, RouterModule, SafePipe],
})
export class ProductRecommendedComponent {
    @Input() imageUrl: string = undefined;
    @Input() heading: string = '';
    @Input() linkUrl: string = '';
    getWebpImg: (src: string) => string;

    constructor(webpService: WebpService) {
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
